module.exports = __webpack_public_path__ + "static/img/1348_phase_function_Paper_Points.8ccd1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1348_phase_function_Paper_Points.png
// module id = GdVR
// module chunks = 0